import React from "react";
export const LoadingSpinner = (props) => {
    const divStyle = "w-full flex justify-center";
    const style = props.style ? `${divStyle} ${props.style}` : divStyle;
    return (React.createElement("div", { className: style },
        React.createElement("img", { className: "h-44 w-44", src: "/assets/images/loader-spinners/8thLight-Loader.gif", alt: "Loading..." })));
};
